import React from 'react';
import moment from 'moment-timezone';

import MFormDateTimePickerView from './MFormDateTimePicker.view';

import { MFormFieldProps } from 'views/MForm/MForm.model';
import { DatePickerFormats } from 'utils/enums/time-format';

type Props = MFormFieldProps<[moment.Moment | null], moment.Moment | null> & {
  disabled?: boolean;
  showTimeSelect?: boolean;
  dateFormat?: DatePickerFormats;
  className?: string;
  timeIntervals?: number;
  showTimeSelectOnly?: boolean;
  showYearDropdown?: boolean;
  clearButton?: boolean;
  maxDate?: moment.Moment | null;
  minDate?: moment.Moment | null;
  showResetDate?: boolean;
};

const MFormDateTimePicker: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const promptChange = (value: moment.Moment | null) => {
    if (!value || !value.isValid()) {
      props.onChange(null);

      return;
    }

    props.onChange(value);
  };

  return (
    <MFormDateTimePickerView
      disabled={props.disabled}
      valid={props.valid}
      invalid={props.invalid}
      value={props.value && props.value?.isValid() ? props.value : null}
      showTimeSelect={props.showTimeSelect}
      dateFormat={props.dateFormat}
      className={props.className}
      timeIntervals={props.timeIntervals}
      showTimeSelectOnly={props.showTimeSelectOnly}
      showYearDropdown={props.showYearDropdown}
      onChange={promptChange}
      clearButton={props.clearButton}
      minDate={props.minDate}
      maxDate={props.maxDate}
      showResetDate={props.showResetDate}
    ></MFormDateTimePickerView>
  );
};

MFormDateTimePicker.displayName = 'MFormDateTimePicker';
MFormDateTimePicker.defaultProps = {};

export default MFormDateTimePicker;
